module.exports = __webpack_public_path__ + "img/main_img_1.88c89bf6.png";